import apiChange from '../apiChange';

import { ParamsBodyPostCreateChangeSolicitation } from 'utils/typeServices';

type response = {
    success: boolean;
    message: string;
    errorCode: string;
    data: {
        cD_SOLICITACAO: number;
    }
}

export const PostCreateChangeSolicitation = async ({ body }: { body: ParamsBodyPostCreateChangeSolicitation }) => {
    const bodyJson = JSON.stringify(body);
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiChange.post<response>('/changeowner/createChangeSolicitation/v1', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data;
    } catch (error) {
        return null;
    }
}
